<div style="position: relative; /* or absolute */
top: 0%;
left: 1%;
width: 97%;">
    @if (isEditingExistingService) {
        <h2>{{ 'SERVICE.EDIT_SERVICE' | translate:{name: service.name} }}</h2>
    } @else {
        <h2>{{"SERVICE.ADD_SERVICE" | translate}}</h2>
    }

    @if (error) {
        <div class="alert alert-danger">{{error}}</div>
    }

    <div class="col-xs-12">
        <div [hidden]="submitted">
            <form (ngSubmit)="onSubmit()" #serviceForm="ngForm">
                <button type="submit" class="btn btn-primary" style="float: right;" [disabled]="!serviceForm.form.valid">{{'FUNCTION-BUTTONS.SAVE' | translate}}
      </button>
                <button class="btn btn-primary" style="float: right; margin-right: 10px;" (click)="goToList()">{{'FUNCTION-BUTTONS.CANCEL' | translate}}</button>

                <br/>
                <br/><br/>
                <div class="form-group">
                    <label for="name">{{'SERVICE.NAME' | translate}}</label>
                    <input type="text" class="form-control" id="name" [(ngModel)]="service.name" name="name" #name="ngModel" required>
                    <div [hidden]="name.valid || name.pristine" class="alert alert-danger">
                        {{'SERVICE.NAME_REQUIRED' | translate}}
                    </div>
                </div>

                <div class="form-group">
                    <label for="code">{{'SERVICE.CODE' | translate}}</label>
                    <input type="text" class="form-control" id="code" [(ngModel)]="service.code" name="code">
                </div>

                <!-- <div class="form-group">
                    <label for="type">{{'SERVICE.TYPE' | translate}}</label>
                    <select [(ngModel)]="service.type" id="type" class="form-control" name="type" #type="ngModel" required (change)="onChange($event.target.value);">
          <option *ngFor="let value of serviceTypes" value={{value.key}}>
            {{value.name}}
          </option>
        </select>
                    <div [hidden]="type.valid || type.pristine" class="alert alert-danger">
                        {{'SERVICE.TYPE_REQUIRED' | translate}}
                    </div>
                </div> -->
                <!--<ng-template [service]="service" service-type-form-fields></ng-template>-->


                <ntr-service-csv [service]="service"  ></ntr-service-csv>
                <!-- <ntr-service-mcas [service]="service" *ngIf="service.type==='2'"></ntr-service-mcas>
                <ntr-service-otp [service]="service" *ngIf="service.type==='3'"></ntr-service-otp> -->

            </form>
        </div>
    </div>
</div>